import * as Yup from "yup";

export const EMAIL_VALIDATION_SCHEMA = Yup.string()
  .trim()
  .email("Invalid email address")
  .matches(
    /^[^@]+@[^@]+\.[^@]+$/,
    "Email must contain a valid '@' symbol and domain"
  )
  .required("Please provide email address");

export const NAME_VALIDATION_SCHEMA = (
  message: string = "Please provide the name"
) => Yup.string().trim().required(message);

export const POSTCODE_VALIDATION_SCHEMA = Yup.string()
  .trim()
  .matches(
    /^([A-Za-z]{1,2}\d[A-Za-z\d]? \d[A-Za-z]{2})$/,
    "Invalid UK postcode format"
  )
  .required("Postcode is required");

export const REQUIRED_FIELD_VALIDATION_SCHEMA = (
  message: string = "Please provide the details"
) => Yup.string().trim().required(message);

export const WEBSITE_VALIDATION_SCHEMA = Yup.string()
  .trim()
  .matches(
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
    "Enter correct url!"
  )
  .required("Please enter website url");

export const PHONE_NUMBER_VALIDATION_SCHEMA = Yup.string()
  .trim()
  .matches(
    /^(?:\+44\s?|0)7\d{3}\s?\d{3}\s?\d{3}$/,
    "Phone number must be a valid UK mobile number"
  )
  .required("Phone number is required");

export const AGE_VALIDATION_SCHEMA = Yup.number()
  .positive("Age must be a positive number")
  .required("Age is required");

export const POSITIVE_NUMBER_VALIDATION_SCHEMA = Yup.number()
  .positive("Value must be a positive number")
  .required("Value is required");

export const PASSWORD_VALIDATION_SCHEMA = Yup.string()
  .min(8, "Password is too short - should be 8 chars minimum.")
  .matches(
    /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{8,}$/,
    "Password must be at least 8 characters long, include at least 1 uppercase letter, 1 special character, 1 digit, and 3 lowercase letters."
  )
  .required("Please provide password");

export const PASSWORD_MATCH_VALIDATION_SCHEMA = Yup.object().shape({
  password: PASSWORD_VALIDATION_SCHEMA,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords do not match")
    .required("Please confirm password"),
});

export const SIGN_IN_VALIDATION_SCHEME = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[^@]+@[^@]+\.[^@]+$/,
      "Email must contain a valid '@' symbol and domain"
    )
    .required("Please provide email address"),
  password: Yup.string()
    .min(8, "Password is too short - should be 8 chars minimum.")
    .matches(
      /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{8,}$/,
      "Password must be at least 8 characters long, include at least 1 uppercase letter, 1 special character, 1 digit, and 3 lowercase letters."
    )
    .required("Please provide password"),
});

export const SIGN_UP_VALIDATION_SCHEME = Yup.object().shape({
  // firstName: Yup.string()
  //   .min(2, "Too Short!")
  //   .max(50, "Too Long!")
  //   .required("Required"),
  // lastName: Yup.string()
  //   .min(2, "Too Short!")
  //   .max(50, "Too Long!")
  //   .required("Required"),
  // email: Yup.string()
  //   .email("Invalid email address")
  //   .matches(
  //     /^[^@]+@[^@]+\.[^@]+$/,
  //     "Email must contain a valid '@' symbol and domain"
  //   )
  //   .required("Please provide email address"),
  // phoneNo: Yup.string()
  //   .matches(
  //     /^(?:\+44\s?|0)7\d{3}\s?\d{3}\s?\d{3}$/,
  //     "Phone number must be a valid UK mobile number"
  //   )
  //   .required("Phone number is required"),
  // password: Yup.string()
  //   .min(8, "Password is too short - should be 8 chars minimum.")
  //   .matches(
  //     /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{8,}$/,
  //     "Password must be at least 8 characters long, include at least 1 uppercase letter, 1 special character, 1 digit, and 3 lowercase letters."
  //   )
  //   .required("Please provide password"),
  //therapies: Yup.array().min(1, "Please select at least one therapy"),
});

export const FORGOT_PASSWORD_VALIDATION_SCHEME = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[^@]+@[^@]+\.[^@]+$/,
      "Email must contain a valid '@' symbol and domain"
    )
    .required("Please provide email address"),
});

export const INVITE_PRACTITIONER_VALIDATION_SCHEME = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[^@]+@[^@]+\.[^@]+$/,
      "Email must contain a valid '@' symbol and domain"
    )
    .required("Please provide email address"),
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

export const OTP_VALIDATION_SCHEME = Yup.object().shape({
  otp: Yup.string()
    .matches(/^[0-9]{4}$/, "OTP must be a 4-digit number")
    .required("Please provide OTP"),
});

export const THERAPY_VALIDATION_SCHEMA = Yup.object().shape({
  therapyId: Yup.string().required("Therapy is required"),
  sessionTime: Yup.string()
    .required("Session Duration is required")
    .matches(/^(\d+):([0-5]\d)$/, "Invalid time format (HH:mm)"),
  perSessionPrice: Yup.string()
    .required("Session Price is required")
    .matches(
      /^\d{1,13}(\.\d{1,2})?$/,
      "Invalid price format (max 15 digits, 2 decimals)"
    )
    .test("is-greater-than-zero", "Price must be greater than 0", (value) => {
      if (!value) return false;
      return parseFloat(value) > 0;
    }),
});

export const EDIT_PROFILE_VALIDATION_SCHEMA = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[^@]+@[^@]+\.[^@]+$/,
      "Email must contain a valid '@' symbol and domain"
    )
    .required("Please provide email address"),
  phoneNo: Yup.string()
    .matches(
      /^(?:\+44\s?|0)7\d{3}\s?\d{3}\s?\d{3}$/,
      "Phone number must be a valid UK mobile number"
    )
    .required("Phone number is required"),
});

export const PRAC_ADD_APPOINTMENT_VALIDATION_SCHEMA = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Invalid email format")
    .required("Email is required"),
  postcode: Yup.string()
    .trim()
    .matches(
      /^([A-Za-z]{1,2}\d[A-Za-z\d]? \d[A-Za-z]{2})$/,
      "Invalid UK postcode format"
    )
    .required("Postcode is required"),
  service: Yup.object()
    .shape({
      value: Yup.number().required("Service is required"),
      label: Yup.string().required("Service label is required"),
    })
    .nullable()
    .required("Service is required"),
  dateOfAppointment: Yup.date()
    .nullable()
    .required("Date of appointment is required"),
  startTime: Yup.string()
    .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, "Invalid time format")
    .required("Start time is required"),
});

export const UPSERT_SERVICE_VALIDATION_SCHEME = Yup.object().shape({
  name: Yup.string().required("Please provide a name"),
  description: Yup.string(),
  expiryDate: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .optional()
    .test("is-future-date", "Please provide a future date", (value) => {
      return !value || value > new Date();
    }),
});

export const UPSERT_FEATURE_VALIDATION_SCHEME = Yup.object().shape({
  label: Yup.string().required("Please provide a lable"),
  isAvailable: Yup.boolean().default(true),
});

export const UPSERT_SUBSCRIPTION_VALIDATION_SCHEME = Yup.object().shape({
  title: Yup.string().required("Please provide a title"),
  subTitle: Yup.string().required("Please provide a sub-title"),
  perDayPrice: Yup.number()
    .required("Please provide a per day price")
    .min(1, "Price should be more then 1"),
  features: Yup.array()
    .of(UPSERT_FEATURE_VALIDATION_SCHEME)
    .min(1, "Please select features"),
  expiryDate: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .optional()
    .test("is-future-date", "Please provide a future date", (value) => {
      return !value || value > new Date();
    }),
  sku: Yup.string().required("Please provide a sku"),
});

export const UPSERT_CLINIC_VALIDATION_SCHEME = Yup.object().shape({
  name: Yup.string().required("Please provide a name"),
  address: Yup.string().required("Please provide a address"),
  postCode: Yup.string().required("Please provide a post code"),
  contactDetails: Yup.string().required("Please provide contact details"),
  noOfAvailableRooms: Yup.number()
    .required("Please provide no. of rooms available")
    .min(1, "Number should be more then 1"),
});

export const SIGN_UP_BIO_VALIDATION_SCHEME = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  lastName: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[^@]+@[^@]+\.[^@]+$/,
      "Email must contain a valid '@' symbol and domain"
    )
    .required("Please provide email address"),
  contactNumber: Yup.string()
    .matches(
      /^(?:\+44\s?|0)7\d{3}\s?\d{3}\s?\d{3}$/,
      "Contact number must be a valid UK mobile number"
    )
    .required("Phone number is required"),
  password: Yup.string()
    .min(8, "Password is too short - should be 8 chars minimum.")
    .matches(
      /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{8,}$/,
      "Password must be at least 8 characters long, include at least 1 uppercase letter, 1 special character, 1 digit, and 3 lowercase letters."
    )
    .required("Please provide password"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords do not match")
    .required("Please confirm your password"),
});